$(document).ready(function() {
	MicroModal.init({
		onShow: function(modal) {
			console.log(modal.id + ' is now showing!');
		},
		onClose: function(modal) {
			console.log(modal.id + ' has been closed');
		}
	});

  $('.video-container').on('click', function() {
    var videoId = $(this).data('video-id');
    var videoType = $(this).data('video-type');
    var modalContent = '<iframe id="youtubePlayer" src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&controls=0&mute=0&loop=1&enablejsapi=1&rel=0&modestbranding=1&origin={{ \'https://\' | append: request.host | url_encode }}" allow="autoplay; encrypted-media" allowfullscreen="allowfullscreen" width: 100%; height: 100%;></iframe>';
    MicroModal.show('youtube-modal', {
      onShow: (modal) => {
       document.querySelector('.modal__content').innerHTML = modalContent;
        // var iframe = document.getElementById('youtubePlayer');
        // iframe.src = iframe.src.replace("mute=1", "mute=0");
      }
    });
  });

  $('.modal__overlay').click(function() {
    MicroModal.close('youtube-modal')
    $('.modal__content').html('');
  })
});
